import { render, staticRenderFns } from "./Revy.vue?vue&type=template&id=7abf5b82"
import script from "./Revy.vue?vue&type=script&lang=js"
export * from "./Revy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports